export default __webpack_public_path__ + "static/media/Empty_NoTask.daec4644.svg";